import { render, staticRenderFns } from "./ConfirmacionEliminar.vue?vue&type=template&id=6adab9e6&"
import script from "./ConfirmacionEliminar.vue?vue&type=script&lang=ts&"
export * from "./ConfirmacionEliminar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6adab9e6', component.options)
    } else {
      api.reload('6adab9e6', component.options)
    }
    module.hot.accept("./ConfirmacionEliminar.vue?vue&type=template&id=6adab9e6&", function () {
      api.rerender('6adab9e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Mantenedor/ConfirmacionEliminar.vue"
export default component.exports